import { IQuery } from '../interfaces';
import { Filter } from '../models/filter';
import { AttendanceRouteHandler } from './AttendanceRouteHandler';
import { AttendanceDegreeTypeRouteHandler } from './AttendanceDegreeTypeRouteHandler';
import { ContinentRouteHandler } from './ContinentRouteHandler';
import { CountryAreaRouteHandler } from './CountryAreaRouteHandler';
import { CountryDegreeTypeRouteHandler } from './CountryDegreeTypeRouteHandler';
import { CountryAttendanceMbaRouteHandler } from './CountryAttendanceMbaRouteHandler';
import { CountryDurationRouteHandler } from './CountryDurationRouteHandler';
import { CountryEducationalFormRouteHandler } from './CountryEducationalFormRouteHandler';
import { CountryFormatRouteHandler } from './CountryFormatRouteHandler';
import { CountryRouteHandler } from './CountryRouteHandler';
import { CountryTuitionFeeRouteHandler } from './CountryTuitionFeeRouteHandler';
import { DisciplineContinentRouteHandler } from './DisciplineContinentRouteHandler';
import { DisciplineCountryAreaRouteHandler } from './DisciplineCountryAreaRouteHandler';
import { DisciplineCountryRouteHandler } from './DisciplineCountryRouteHandler';
import { DisciplineCountryDegreeTypeRouteHandler } from './DisciplineCountryDegreeTypeRouteHandler';
import { DisciplineDegreeTypeRouteHandler } from './DisciplineDegreeTypeRouteHandler';
import { DisciplineDeliveryMethodRouteHandler } from './DisciplineDeliveryMethodRouteHandler';
import { DisciplineDurationRouteHandler } from './DisciplineDurationRouteHandler';
import { DisciplineEducationalFormCountryRouteHandler } from './DisciplineEducationalFormCountryRouteHandler';
import { DisciplineEducationalFormRouteHandler } from './DisciplineEducationalFormRouteHandler';
import { DisciplineFormatRouteHandler } from './DisciplineFormatRouteHandler';
import { DisciplineRouteHandler } from './DisciplineRouteHandler';
import { DisciplineTuitionFeeDeliveryMethodRouteHandler } from './DisciplineTuitionFeeDeliveryMethodRouteHandler';
import { DisciplineTuitionFeeRouteHandler } from './DisciplineTuitionFeeRouteHandler';
import { PortalRouteHandler } from './PortalRouteHandler';
import { CountryAttendanceRouteHandler } from './CountryAttendanceRouteHandler';
import { SpecialProgrammesRouteHandler } from './SpecialProgrammesRouteHandler';
import { CountryDegreeTypeOneYearRouteHandler } from './CountryDegreeTypeOneYearRouteHandler';
import { TuitionFeeRouteHandler } from './TuitionFeeRouteHandler';
import { TuitionFeeContinentRouteHandler } from './TuitionFeeContinentRouteHandler';
import { DegreeTypeDeliveryMethodDisciplineRouteHandler } from './DegreeTypeDeliveryMethodDisciplineRouteHandler';
import { DegreeTypeCountryTuitionFeeRouteHandler } from './DegreeTypeCountryTuitionFeeRouteHandler';
import { DegreeTypeCountryDeliveryMethodRouteHandler } from './DegreeTypeCountryDeliveryMethodRouteHandler';
import { DegreeTypeRouteHandler } from './DegreeTypeRouteHandler';
import { FormatRouteHandler } from './FormatRouteHandler';
import { DegreeTypeFormatRouteHandler } from './DegreeTypeFormatRouteHandler';
import { DegreeTypeTuitionFeeDeliveryMethodRouteHandler } from './DegreeTypeTuitionFeeDeliveryMethodRouteHandler';
import { DegreeTypeAreaRouteHandler	} from './DegreeTypeAreaRouteHandler';
import { DegreeTypeTuitionFeeRouteHandler } from './DegreeTypeTuitionFeeRouteHandler';
import { DegreeTypeContinentRouteHandler } from './DegreeTypeContinentRouteHandler';
import { TuitionFeeDeliveryMethodRouteHandler } from './TuitionFeeDeliveryMethodRouteHandler';
import { DurationRouteHandler } from './DurationRouteHandler';
import { DeliveryMethodDurationRouteHandler } from './DeliveryMethodDurationRouteHandler';
import { DeliveryMethodDisciplineContinentRouteHandler } from './DeliveryMethodDisciplineContinentRouteHandler';
import { DegreeTypeTuitionFeeContinentRouteHandler } from './DegreeTypeTuitionFeeContinentRouteHandler';
import { FormatDeliveryMethodRouteHandler } from './FormatDeliveryMethodRouteHandler';
import { DeliveryMethodContinentRouteHandler } from './DeliveryMethodContinentRouteHandler';
import { FormatContinentRouteHandler } from './FormatContinentRouteHandler';
import { DegreeTypeDurationRouteHandler } from './DegreeTypeDurationRouteHandler';
import { SpecialProgrammesContinentRouteHandler } from './SpecialProgrammesContinentRouteHandler';
import { SpecialProgrammesCountryRouteHandler } from './SpecialProgrammesCountryRouteHandler';
import { FormatAttendanceRouteHandler } from './FormatAttendanceRouteHandler';
import { AttendanceAreaRouteHandler } from './AttendanceAreaRouteHandler';
import { DegreeTypeTuitionFeeFormatRouteHandler } from './DegreeTypeTuitionFeeFormatRouteHandler';
import { DurationContinentRouteHandler } from './DurationContinentRouteHandler';
import { SpecialProgrammesDisciplineRouteHandler } from './SpecialProgrammesDisciplineRouteHandler';
import { DegreeTypeFormatAttendanceRouteHandler } from './DegreeTypeFormatAttendanceRouteHandler';
import { AttendanceDisciplineCountryRouteHandler } from './AttendanceDisciplineCountryRouteHandler';
import { FormatDisciplineCountryRouteHandler } from './FormatDisciplineCountryRouteHandler';
import { DegreeTypeSpecialProgrammesRouteHandler } from './DegreeTypeSpecialProgrammesRouteHandler';
import { DegreeTypeSpecialProgrammesAttendanceRouteHandler } from './DegreeTypeSpecialProgrammesAttendanceRouteHandler';
import { DegreeTypeTuitionFeeAreaRouteHandler } from './DegreeTypeTuitionFeeAreaRouteHandler';

class RoutingHelper {
	private portalRouteHandler = new PortalRouteHandler();
	private disciplineRouteHandler = new DisciplineRouteHandler();
	private disciplineDegreeTypeRouteHandler = new DisciplineDegreeTypeRouteHandler();
	private disciplineDurationRouteHandler = new DisciplineDurationRouteHandler();
	private disciplineEducationalFormRouteHandler = new DisciplineEducationalFormRouteHandler();
	private disciplineEducationalFormCountryRouteHandler = new DisciplineEducationalFormCountryRouteHandler();
	private disciplineFormatRouteHandler = new DisciplineFormatRouteHandler();
	private disciplineTuitionFeeRouteHandler = new DisciplineTuitionFeeRouteHandler();
	private disciplineTuitionFeeDeliveryMethodRouteHandler = new DisciplineTuitionFeeDeliveryMethodRouteHandler();
	private disciplineDeliveryMethodRouteHandler = new DisciplineDeliveryMethodRouteHandler();
	private formatRouteHandler = new FormatRouteHandler();
	private formatDeliveryMethodRouteHandler = new FormatDeliveryMethodRouteHandler();
	private formatContinentRouteHandler = new FormatContinentRouteHandler();
	private degreeTypeFormatRouteHandler = new DegreeTypeFormatRouteHandler();
	private degreeTypeContinentRouteHandler = new DegreeTypeContinentRouteHandler();
	private degreeTypeAreaRouteHandler = new DegreeTypeAreaRouteHandler();
	private degreeTypeTuitionFeeAttendanceRouteHandler = new DegreeTypeTuitionFeeDeliveryMethodRouteHandler();
	private countryFormatRouteHandler = new CountryFormatRouteHandler();
	private countryDegreeTypeOneYearRouteHandler = new CountryDegreeTypeOneYearRouteHandler();
	private countryDegreeTypeRouteHandler = new CountryDegreeTypeRouteHandler();
	private countryAttendanceMbaRouteHandler = new CountryAttendanceMbaRouteHandler();
	private countryAttendanceRouteHandler = new CountryAttendanceRouteHandler();
	private countryDurationRouteHandler = new CountryDurationRouteHandler();
	private countryEducationalFormRouteHandler = new CountryEducationalFormRouteHandler();
	private countryRouteHandler = new CountryRouteHandler();
	private degreeTypeRouteHandler = new DegreeTypeRouteHandler();
	private countryTuitionFeeRouteHandler = new CountryTuitionFeeRouteHandler();
	private disciplineCountryRouteHandler = new DisciplineCountryRouteHandler();
	private disciplineCountryDegreeTypeRouteHandler = new DisciplineCountryDegreeTypeRouteHandler();
	private continentRouteHandler = new ContinentRouteHandler();
	private disciplineContinentRouteHandler = new DisciplineContinentRouteHandler();
	private countryAreaRouteHandler = new CountryAreaRouteHandler();
	private disciplineCountryAreaRouteHandler = new DisciplineCountryAreaRouteHandler();
	private attendanceRouteHandler = new AttendanceRouteHandler();
	private attendanceDegreeTypeRouteHandler = new AttendanceDegreeTypeRouteHandler();
	private specialProgrammesRouteHandler = new SpecialProgrammesRouteHandler();
	private tuitionFeeRouteHandler = new TuitionFeeRouteHandler();
	private tuitionFeeContinentRouteHandler = new TuitionFeeContinentRouteHandler();
	private degreeTypeDeliveryMethodDisciplineRouteHandler = new DegreeTypeDeliveryMethodDisciplineRouteHandler();
	private degreeTypeCountryTuitionFeeRouteHandler = new DegreeTypeCountryTuitionFeeRouteHandler();
	private degreeTypeCountryDeliveryMethodRouteHandler = new DegreeTypeCountryDeliveryMethodRouteHandler();
	private degreeTypeTuitionFeeRouteHandler = new DegreeTypeTuitionFeeRouteHandler();
	private tuitionFeeDeliveryMethodRouteHandler = new TuitionFeeDeliveryMethodRouteHandler();
	private durationRouteHandler = new DurationRouteHandler();
	private deliveryMethodDurationRouteHandler = new DeliveryMethodDurationRouteHandler();
	private deliveryMethodDisciplineContinentRouteHandler = new DeliveryMethodDisciplineContinentRouteHandler();
	private degreeTypeTuitionFeeContinentRouteHandler = new DegreeTypeTuitionFeeContinentRouteHandler();
	private deliveryMethodContinentRouteHandler = new DeliveryMethodContinentRouteHandler();
	private degreeTypeDurationRouteHandler = new DegreeTypeDurationRouteHandler();
	private specialProgrammesContinentRouteHandler = new SpecialProgrammesContinentRouteHandler();
	private specialProgrammesCountryRouteHandler = new SpecialProgrammesCountryRouteHandler();
	private formatAttendanceRouteHandler = new FormatAttendanceRouteHandler();
	private attendanceAreaRouteHandler = new AttendanceAreaRouteHandler();
	private degreeTypeTuitionFeeFormatRouteHandler = new DegreeTypeTuitionFeeFormatRouteHandler();
	private durationContinentRouteHandler = new DurationContinentRouteHandler();
	private specialProgrammesDisciplineRouteHandler = new SpecialProgrammesDisciplineRouteHandler();
	private degreeTypeFormatAttendanceRouteHandler = new DegreeTypeFormatAttendanceRouteHandler();
	private attendanceDisciplineCountryRouteHandler = new AttendanceDisciplineCountryRouteHandler();
	private formatDisciplineCountryRouteHandler = new FormatDisciplineCountryRouteHandler();
	private degreeTypeSpecialProgrammesRouteHandler = new DegreeTypeSpecialProgrammesRouteHandler();
	private degreeTypeSpecialProgrammesAttendanceRouteHandler = new DegreeTypeSpecialProgrammesAttendanceRouteHandler();
	private degreeTypeTuitionFeeAreaRouteHandler = new DegreeTypeTuitionFeeAreaRouteHandler();
	private handlers = [
		this.portalRouteHandler,
		this.disciplineRouteHandler,
		this.disciplineDegreeTypeRouteHandler,
		this.disciplineDurationRouteHandler,
		this.disciplineEducationalFormRouteHandler,
		this.disciplineEducationalFormCountryRouteHandler,
		this.disciplineFormatRouteHandler,
		this.disciplineTuitionFeeRouteHandler,
		this.disciplineTuitionFeeDeliveryMethodRouteHandler,
		this.disciplineDeliveryMethodRouteHandler,
		this.formatRouteHandler,
		this.formatDeliveryMethodRouteHandler,
		this.formatContinentRouteHandler,
		this.degreeTypeFormatRouteHandler,
		this.degreeTypeContinentRouteHandler,
		this.degreeTypeAreaRouteHandler,
		this.degreeTypeTuitionFeeAttendanceRouteHandler,
		this.degreeTypeTuitionFeeContinentRouteHandler,
		this.degreeTypeDurationRouteHandler,
		this.countryFormatRouteHandler,
		this.countryDegreeTypeOneYearRouteHandler,
		this.countryDegreeTypeRouteHandler,
		this.countryAttendanceMbaRouteHandler,
		this.countryAttendanceRouteHandler,
		this.countryDurationRouteHandler,
		this.countryEducationalFormRouteHandler,
		this.countryRouteHandler,
		this.degreeTypeRouteHandler,
		this.countryTuitionFeeRouteHandler,
		this.disciplineCountryRouteHandler,
		this.disciplineCountryDegreeTypeRouteHandler,
		this.continentRouteHandler,
		this.disciplineContinentRouteHandler,
		this.countryAreaRouteHandler,
		this.disciplineCountryAreaRouteHandler,
		this.attendanceRouteHandler,
		this.attendanceDegreeTypeRouteHandler,
		this.specialProgrammesRouteHandler,
		this.tuitionFeeRouteHandler,
		this.tuitionFeeContinentRouteHandler,
		this.degreeTypeDeliveryMethodDisciplineRouteHandler,
		this.degreeTypeCountryTuitionFeeRouteHandler,
		this.degreeTypeCountryDeliveryMethodRouteHandler,
		this.degreeTypeTuitionFeeRouteHandler,
		this.tuitionFeeDeliveryMethodRouteHandler,
		this.durationRouteHandler,
		this.deliveryMethodDurationRouteHandler,
		this.deliveryMethodDisciplineContinentRouteHandler,
		this.degreeTypeTuitionFeeContinentRouteHandler,
		this.specialProgrammesContinentRouteHandler,
		this.specialProgrammesCountryRouteHandler,
		this.formatAttendanceRouteHandler,
		this.attendanceAreaRouteHandler,
		this.degreeTypeTuitionFeeFormatRouteHandler,
		this.durationContinentRouteHandler,
		this.specialProgrammesDisciplineRouteHandler,
		this.degreeTypeFormatAttendanceRouteHandler,
		this.attendanceDisciplineCountryRouteHandler,
		this.formatDisciplineCountryRouteHandler,
		this.degreeTypeSpecialProgrammesRouteHandler,
		this.degreeTypeSpecialProgrammesAttendanceRouteHandler,
		this.degreeTypeTuitionFeeAreaRouteHandler
	];

	public constructor() {
		this.degreeTypeTuitionFeeAreaRouteHandler.setNext(this.disciplineTuitionFeeDeliveryMethodRouteHandler);
		this.disciplineTuitionFeeDeliveryMethodRouteHandler.setNext(this.degreeTypeDeliveryMethodDisciplineRouteHandler);
		this.degreeTypeDeliveryMethodDisciplineRouteHandler.setNext(this.deliveryMethodDisciplineContinentRouteHandler);
		this.deliveryMethodDisciplineContinentRouteHandler.setNext(this.disciplineEducationalFormCountryRouteHandler);
		this.disciplineEducationalFormCountryRouteHandler.setNext(this.disciplineCountryAreaRouteHandler);
		this.disciplineCountryAreaRouteHandler.setNext(this.disciplineCountryDegreeTypeRouteHandler);
		this.disciplineCountryDegreeTypeRouteHandler.setNext(this.attendanceDisciplineCountryRouteHandler);
		this.attendanceDisciplineCountryRouteHandler.setNext(this.formatDisciplineCountryRouteHandler);
		this.formatDisciplineCountryRouteHandler.setNext(this.degreeTypeSpecialProgrammesAttendanceRouteHandler);
		this.degreeTypeSpecialProgrammesAttendanceRouteHandler.setNext(this.degreeTypeTuitionFeeFormatRouteHandler);
		this.degreeTypeTuitionFeeFormatRouteHandler.setNext(this.degreeTypeFormatAttendanceRouteHandler);

		this.degreeTypeFormatAttendanceRouteHandler.setNext(this.disciplineDegreeTypeRouteHandler);
		this.disciplineDegreeTypeRouteHandler.setNext(this.disciplineDurationRouteHandler);
		this.disciplineDurationRouteHandler.setNext(this.disciplineFormatRouteHandler);
		this.disciplineFormatRouteHandler.setNext(this.disciplineTuitionFeeRouteHandler);
		this.disciplineTuitionFeeRouteHandler.setNext(this.disciplineDeliveryMethodRouteHandler);
		this.disciplineDeliveryMethodRouteHandler.setNext(this.disciplineEducationalFormRouteHandler);
		this.disciplineEducationalFormRouteHandler.setNext(this.disciplineCountryRouteHandler);
		this.disciplineCountryRouteHandler.setNext(this.disciplineContinentRouteHandler);
		this.disciplineContinentRouteHandler.setNext(this.countryDegreeTypeOneYearRouteHandler);
		this.countryDegreeTypeOneYearRouteHandler.setNext(this.countryDegreeTypeRouteHandler);
		this.countryDegreeTypeRouteHandler.setNext(this.countryAttendanceMbaRouteHandler);
		this.countryAttendanceMbaRouteHandler.setNext(this.countryAttendanceRouteHandler);
		this.countryAttendanceRouteHandler.setNext(this.countryDurationRouteHandler);
		this.countryDurationRouteHandler.setNext(this.countryEducationalFormRouteHandler);
		this.countryEducationalFormRouteHandler.setNext(this.countryTuitionFeeRouteHandler);
		this.countryTuitionFeeRouteHandler.setNext(this.countryFormatRouteHandler);
		this.countryFormatRouteHandler.setNext(this.attendanceDegreeTypeRouteHandler);
		this.attendanceDegreeTypeRouteHandler.setNext(this.tuitionFeeContinentRouteHandler);
		this.tuitionFeeContinentRouteHandler.setNext(this.tuitionFeeDeliveryMethodRouteHandler);
		this.tuitionFeeDeliveryMethodRouteHandler.setNext(this.deliveryMethodDurationRouteHandler);
		this.deliveryMethodDurationRouteHandler.setNext(this.deliveryMethodContinentRouteHandler);
		this.deliveryMethodContinentRouteHandler.setNext(this.formatContinentRouteHandler);
		this.formatContinentRouteHandler.setNext(this.formatDeliveryMethodRouteHandler);
		this.formatDeliveryMethodRouteHandler.setNext(this.formatAttendanceRouteHandler);
		this.formatAttendanceRouteHandler.setNext(this.attendanceAreaRouteHandler);
		this.attendanceAreaRouteHandler.setNext(this.degreeTypeContinentRouteHandler);
		this.degreeTypeContinentRouteHandler.setNext(this.degreeTypeFormatRouteHandler);
		this.degreeTypeFormatRouteHandler.setNext(this.degreeTypeAreaRouteHandler);
		this.degreeTypeAreaRouteHandler.setNext(this.degreeTypeTuitionFeeAttendanceRouteHandler);
		this.degreeTypeTuitionFeeAttendanceRouteHandler.setNext(this.degreeTypeTuitionFeeContinentRouteHandler);
		this.degreeTypeTuitionFeeContinentRouteHandler.setNext(this.degreeTypeDurationRouteHandler);
		this.degreeTypeDurationRouteHandler.setNext(this.degreeTypeTuitionFeeRouteHandler);
		this.degreeTypeTuitionFeeRouteHandler.setNext(this.degreeTypeCountryTuitionFeeRouteHandler);
		this.degreeTypeCountryTuitionFeeRouteHandler.setNext(this.degreeTypeCountryDeliveryMethodRouteHandler);
		this.degreeTypeCountryDeliveryMethodRouteHandler.setNext(this.specialProgrammesContinentRouteHandler);
		this.specialProgrammesContinentRouteHandler.setNext(this.specialProgrammesCountryRouteHandler);
		this.specialProgrammesCountryRouteHandler.setNext(this.specialProgrammesDisciplineRouteHandler);
		this.specialProgrammesDisciplineRouteHandler.setNext(this.degreeTypeSpecialProgrammesRouteHandler);
		this.degreeTypeSpecialProgrammesRouteHandler.setNext(this.countryAreaRouteHandler);
		this.countryAreaRouteHandler.setNext(this.durationContinentRouteHandler);

		this.durationContinentRouteHandler.setNext(this.disciplineRouteHandler);
		this.disciplineRouteHandler.setNext(this.countryRouteHandler);
		this.countryRouteHandler.setNext(this.degreeTypeRouteHandler);
		this.degreeTypeRouteHandler.setNext(this.specialProgrammesRouteHandler);
		this.specialProgrammesRouteHandler.setNext(this.tuitionFeeRouteHandler);
		this.tuitionFeeRouteHandler.setNext(this.durationRouteHandler);
		this.durationRouteHandler.setNext(this.attendanceRouteHandler);
		this.attendanceRouteHandler.setNext(this.formatRouteHandler);
		this.formatRouteHandler.setNext(this.continentRouteHandler);
		this.continentRouteHandler.setNext(this.portalRouteHandler);
	}

	public async changeUrl(filters: Filter[], query: IQuery, pageNumber: number): Promise<void> {
		await this.degreeTypeTuitionFeeAreaRouteHandler.handle(filters, query, pageNumber);
	}

	public async resolveToUrl(filters: Filter[], query: IQuery, pageNumber: number): Promise<string | undefined> {
		return await this.degreeTypeTuitionFeeAreaRouteHandler.resolveToUrl(filters, query, pageNumber);
	}

	public canBePrettified(filters: Filter[], path: string): boolean {
		const handler = this.handlers.find((_) => _.canHandle(filters) && !(_ instanceof PortalRouteHandler));

		if (handler === undefined) {
			return false;
		}

		return Object.keys(handler.getPathParametersForFilters(filters)).length > this.getPathLength(path);
	}

	private getPathLength(path: string): number {
		return path.split('/').length - 1;
	}
}

export default new RoutingHelper();
